import { Grid } from '@mui/material';
import { getMonth } from '@nx-smartmonkey/shared/helpers';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { HomePreferencesIcon } from '../../../assets/svg/HomePreferencesIcon';
import { useRetrieveActiveLanguage } from '../../../hooks/translations/useRetrieveActiveLanguage';
import { Text } from '../../../react-components/Text';
import { useRetrieveVehicle } from '../hooks/useRetrieveVehicle';

interface HeaderProps {
  onOpenPreferences: () => void;
}

export const Header = ({ onOpenPreferences }: HeaderProps) => {
  const { data: vehicleData } = useRetrieveVehicle();
  const { activeLanguage } = useRetrieveActiveLanguage();
  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      wrap="nowrap"
      style={{
        padding: `20px`,
      }}
    >
      {vehicleData ? (
        <Grid item container direction="row" wrap="nowrap" alignItems="center" style={{ position: `relative` }}>
          <Grid item container direction="column">
            <Text
              variant="body-large"
              isBold
              style={{ color: RoutalPalette.neutral02, textAlign: `center`, textTransform: `capitalize` }}
            >
              {getMonth({
                date: new Date(),
                language: activeLanguage,
                large: true,
              })}
            </Text>
          </Grid>

          <Grid
            item
            onClick={() => onOpenPreferences()}
            style={{ position: `absolute`, right: 0, top: 1, width: `24px` }}
          >
            <HomePreferencesIcon />
          </Grid>
        </Grid>
      ) : null}
    </Grid>
  );
};
